import { Provider as I18nProvider } from '@teamleader/i18n';
import React, { useCallback } from 'react';

interface TranslationsProps {
  loader: React.ReactElement;
  language: string | null;
  loading: boolean;
  children: React.ReactNode;
}

const Translations: React.FC<TranslationsProps> = ({ loader, language, loading, children }) => {
  const getPath = useCallback((language: string) => {
    if (__DEV__) {
      return `/translations.json`;
    }

    return `/translations/${__TRANSLATIONS_MANIFEST__[language]}`;
  }, []);

  if (!language) {
    return loader;
  }

  return (
    <I18nProvider path={getPath} namespace="domains.cloudsign" locale={language} fallback={loader}>
      {loading ? loader : children}
    </I18nProvider>
  );
};

export default Translations;
